import { render, staticRenderFns } from "./CommunityOfficersList.vue?vue&type=template&id=5e3c566f&scoped=true&"
import script from "./CommunityOfficersList.vue?vue&type=script&lang=js&"
export * from "./CommunityOfficersList.vue?vue&type=script&lang=js&"
import style0 from "./CommunityOfficersList.vue?vue&type=style&index=0&id=5e3c566f&lang=scss&scoped=true&"
import style1 from "./CommunityOfficersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c566f",
  null
  
)

export default component.exports